import {
  InvoicesColumn,
  InvoicesColumns,
} from "@portal/BaseComponents/Table/Components/Invoices/InvoicesColumn";

import { PaymentList } from "@portal/types/entities/payment";
import { CellRenderProps } from "@sinecycle/growcomponents";
import { sum } from "lodash";
import { useMemo } from "react";

function AssociatedInvoices(props: CellRenderProps<PaymentList>) {
  const { data } = props;

  function getInvoices(): InvoicesColumns[] {
    if (!data) return [];
    return data.invoices.map((invoice) => {
      return {
        id: invoice.id,
        title: invoice.number,
        amount: sum(
          data.invoice_payments[invoice.id].map((payment) => payment.amount)
        ),
        currency: invoice.currency,
      };
    });
  }

  const invoices = useMemo(getInvoices, [data]);
  return <InvoicesColumn {...props} value={invoices} />;
}

export { AssociatedInvoices };
